/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum Code_typeEnum {
  "QR_CODE" = "QR_CODE",

  "BARCODE_128_AIM" = "BARCODE_128_AIM",

  "BARCODE_GS1_128" = "BARCODE_GS1_128"
}

// required attributes
const EncodingR = t.interface({
  code_type: enumType<Code_typeEnum>(Code_typeEnum, "code_type"),

  encoding_code: t.string
});

// optional attributes
const EncodingO = t.partial({});

export const Encoding = t.intersection([EncodingR, EncodingO], "Encoding");

export type Encoding = t.TypeOf<typeof Encoding>;
